import React from 'react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import DictionaryFieldPmnFunctionDropdown from '../components/DictionaryFieldPmnFunctionDropdown';
import DictionaryFieldValue from './DictionaryFieldValue';
import { pmnFunctionStore } from '../../pmn-functions/constants';
import DictionaryFieldContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/DictionaryFieldContainer';
import {
  ruleFromCode,
  ruleToFieldProps,
  validRuleFromFunction,
} from '../../pmn-functions/helper';

const DictionaryFieldPmnRuleTableCell = ({
  code,
  category,
  dictionaryUUID,
  fieldUUID,
  isEditing,
  exists,
  canRead,
  canEdit,
  updateProperties,
  type,
  pmnRule,
  defaultPmnRuleCode,
  pmnFunctions,
  pmnFunctionsReadStatus,
  template,
}) => {
  const updateFieldPmnRule = (value) => {
    const selectedRule = pmnFunctions.find((o) => o.code === value);
    const rule = validRuleFromFunction(ruleToFieldProps(selectedRule), type, pmnFunctions);
    updateProperties(
      category,
      code,
      dictionaryUUID,
      { pseudonymisation_rule: ruleToFieldProps(rule) },
      fieldUUID,
      template,
    );
  };

  if (!isEditing) {
    const defaultPmnRule = ruleFromCode(pmnFunctionStore, defaultPmnRuleCode);
    const activePmnRule = validRuleFromFunction(pmnRule, type, pmnFunctionStore)
        || defaultPmnRule;

    return (
      <DictionaryFieldValue
        category={category}
        code={code}
        value={activePmnRule ? activePmnRule.name : null}
        canRead={canRead}
        canEdit={canEdit}
        title={activePmnRule ? activePmnRule.description : null}
      />
    );
  }

  const defaultPmnRule = ruleFromCode(pmnFunctions, defaultPmnRuleCode);
  const activePmnRule = validRuleFromFunction(pmnRule, type, pmnFunctions) || defaultPmnRule;

  return (
    <DictionaryFieldContainer
      exists={exists}
      canRead={canRead}
      canEdit={canEdit}
    >
      <DictionaryFieldPmnFunctionDropdown
        onChange={updateFieldPmnRule}
        pmnFunctions={pmnFunctions}
        type={type}
        code={activePmnRule ? activePmnRule.code : null}
        isLoading={pmnFunctionsReadStatus === states.PENDING}
      />
    </DictionaryFieldContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldPmnRuleTableCell);
